import { useCallback, useContext } from 'react';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { SearchLoadingDispatchContext, SearchResultsDispatchContext } from '@/containers/WorkspaceGlobalSearch/Context';
import type { WorkspaceSearchFull } from '@trinity/chat';

export default function useSearchFetchDashboards() {
  const setResults = useContext(SearchResultsDispatchContext);
  const setLoading = useContext(SearchLoadingDispatchContext);

  const apiClient = useChatApiClient();

  const dashboards = useCallback(async ({ filters, size }: FetchData) => {
    const result = await apiClient.workspacesGlobalSearch.dashboards({
      filters,
      size,
    });

    if (result) {
      setResults(prev => ({
        ...prev,
        dashboards: result,
      }));
    }
  }, [apiClient, setResults]);

  const fetch = useCallback(({ filters, size }: FetchData) => {
    setLoading(prev => ({ ...prev, dashboards: { ...prev.dashboards, loading: true } }));
    Promise.all([
      new Promise<void>(resolve => setTimeout(() => resolve(), 250)),
      dashboards({ filters, size }),
    ])
      .then(() => {
        setLoading(prev => ({ ...prev, dashboards: { loading: false } }));
      });
  }, [dashboards, setLoading]);

  return fetch;
}

export { useSearchFetchDashboards };

type FetchData = {
  filters: WorkspaceSearchFull.Brand.Filters;
  size: number;
};